// extracted by mini-css-extract-plugin
module.exports = {"panelHeader":"StakingForm_panelHeader__1xGbJ","numberFormWrap":"StakingForm_numberFormWrap__2Ff5V","claimAndExitBtn":"StakingForm_claimAndExitBtn__yzwCL"};